import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EditsInProjectResponseInterface, ProjectCheckResponseInterface, ProjectResponseInterface } from 'src/app/home/object-info/model/config-api-response.interface';
import { GestioneLoginService } from '../login/gestione-login.service';
import { GestioneUtentiService } from '../utenti/gestione-utenti.service';
import { UtilsService } from '../utils.service';
import { NamSelectedObjectService } from './nam-object-selected.service';
import { WorldService } from './world.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  /**
   * Public key of the sessionStorage.
   * This is to have a single and centralized place for the key of the sessionStorage.
   */
  public PROJECT_ID_KEY = "projectId";

  private _projectName = "";

  /**
   * Tells if a project has already been created.
   * Project by default is not created.
   * This is later edited on the constructor of the service.
   * This variable helps connect several components that need this information without direct communication between components.
   */
  public get hasProject(): boolean {
    return sessionStorage.getItem(this.PROJECT_ID_KEY) != null;
  }

  /**
   * Returns the id of the currently open project, null if no project is open.
   */
  public get projectId() {
    return sessionStorage.getItem(this.PROJECT_ID_KEY);
  }

  public get projectName(): string {
    return this._projectName;
  }

  public set projectName(name: string) {
    let url = this.utils.creaURL("project", "check");
    let params = {};
    params["project_name"] = name;
    
    // Check whether a project with the given name exists or not.
    (this.utils.getRequest(url, params) as Observable<ProjectCheckResponseInterface>).toPromise().then((res) => {
      if (res.error == 0) {
        console.log("PROJECT_IDDDD", res.data.project_id);
        // The project already exists, so save its id.
        this.setProjectId(res.data.project_id);
      } else {
        // Create a project with the given name.
        sessionStorage.removeItem(this.PROJECT_ID_KEY);
        this.getProject();
      }
    });
    this._projectName = name;
  }

  /**
   * Saves info about the project by project id.
   * @param projectId The id of the project to store.
   */
  public async setProjectId(projectId: string) {
    let url = this.utils.creaURL("project", "editsInProject");
    let params = {};
    params["project_id"] = projectId;

    let result = await (this.utils.getRequest(url, params) as Observable<EditsInProjectResponseInterface>).toPromise();
    if (result.error == 0) {
      sessionStorage.setItem(this.PROJECT_ID_KEY, projectId);
    }
  }

  constructor(
    private utils: UtilsService,
    private gestioneUtentiService: GestioneUtentiService,
    private gestioneLoginService: GestioneLoginService
  ) { }

  /**
   * Getter for the project name. If there is no project created already it creates a new one.
   * It then saves the project ID to the session storage and returns it.
   * @returns Project id as string.
   */
  async getProject(): Promise<string> {
    let existing = sessionStorage.getItem(this.PROJECT_ID_KEY);
    if (!existing) {
      let datetimeNow = new Date().toISOString();
      let projectName = (this._projectName == "" ? "NAM|" + datetimeNow : this._projectName + "|" + datetimeNow);
      console.log("COMPOSED_NAME", projectName);
      let projectId = null;

      let data = (await this.createProject(projectName).toPromise());
      console.log("CREATED_PROJECT", projectName, data);

      if (data.error == 1) {
        //There was an error creating the project.
        projectId = null;
      } else {
        projectId = data.data.projectId;
      }

      sessionStorage.setItem(this.PROJECT_ID_KEY, projectId);
      console.log("PROJECT_ID", sessionStorage.getItem(this.PROJECT_ID_KEY));
      return projectId;
    } else {
      console.log("PROJECT_ID", sessionStorage.getItem(this.PROJECT_ID_KEY));
      return existing;
    }
  }

  /**
   * Creates a project with a name passsed as parameter using the API. 
   * Returns the observable of the request. 
   * @param projectName Name of the project.
   * @returns Observable of the request.
   */
  createProject(projectName: string) {
    let url = this.utils.creaURL("project", "create");
    let params = {};
    params["project_name"] = projectName;
    return this.utils.getRequest(url, params) as Observable<ProjectResponseInterface>;
  }

  /**
   * Saves the current project and removes it from the session.
   */
  async sendProject() {
    // Save before closing
    let url = this.utils.creaURL("project", "send");
    let datetimeNow = new Date().toISOString();
    let projectName = (this.projectName == "" ? "NAM" : this.projectName) + "|" + datetimeNow;
    let result = await (this.gestioneUtentiService.userGetByToken({ 'tokens': [this.gestioneLoginService.getToken()] }).toPromise()) as any; // TODO Change "any" type
    let user = result.data[0];
    let params = {};
    params["publish_project_id"] = this.projectId;
    params["name"] = projectName;
    params["user"] = user.credentials.username;
    params["type"] = "NAM";

    await (this.utils.getRequest(url, params) as Observable<ProjectResponseInterface>).toPromise();
    sessionStorage.removeItem(this.PROJECT_ID_KEY);
  }

  /**
   * Deletes the current project and removes it from the session.
   */
  async deleteProject() {
    // Delete the project and remove it.
    let url = this.utils.creaURL("project", "delete");
    let params = {};
    params["project_id"] = this.projectId;
    await (this.utils.getRequest(url, params) as Observable<ProjectResponseInterface>).toPromise();
    sessionStorage.removeItem(this.PROJECT_ID_KEY);
  }

  /**
   * Publish the smallworld project with all the changes.
   * @returns The observable of the request or null if there is no project Id stored on the session storage.
   */
  async publishProject() {
    let projectId = sessionStorage.getItem(this.PROJECT_ID_KEY);
    if (projectId) {
      let url = this.utils.creaURL("project", "send");
      let params = {};
      params["project_id"] = projectId;
      return this.utils.getRequest(url, params)
    } else {
      return null;
    }
  }

  updateFeature(features, worldURN?) {
    let projectId = sessionStorage.getItem(this.PROJECT_ID_KEY);
    if (projectId) {
      let url = this.utils.creaURL("feature", "update");
      let params = {};
      params["project_id"] = projectId;
      return this.utils.getRequest(url, params);
    } else {
      return null;
    }
  }
}
